module.exports = __webpack_public_path__ + "static/img/diagram.9b08e6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/diagram.svg
// module id = eMOv
// module chunks = 31